module.exports = __webpack_public_path__ + "static/media/SaintFrancisXavierSchool.ff4402d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/SaintFrancisXavierSchool.png
// module id = 674
// module chunks = 0